exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"_variables.scss","sourceRoot":""}]);

// exports
exports.locals = {
	"primaryColor": "#00bcd4",
	"accentColor": "#ff5722"
};